import 'core-js/fn/object/assign';
import React from 'react';
import { createRoot } from 'react-dom/client';
import InitMiddlewareComponent from './containers/InitMiddlewareComponent';
import rootReducer from './reducers';
import { Provider } from 'react-redux';
import appConfig from './config';
import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';

require('styles/Main.scss');
import "./styles/glyphicons/css/glyphicons-halflings.css";

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Polyfill for Promise
// Promises not supported by <IE11 not supported
import Promise from 'promise-polyfill';
if (!window.Promise) { window.Promise = Promise; }

// initialize the store
// WIP check if we need (appConfig.env === 'dev') for the logger
// thunkMiddle is automatically added by configureStore
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()//.concat(logger), // add logger middleware if needed
})

/**
 * Launch app!
 * Depending on whether we found .app or .widget, load the specific container.
 */

let app = document.querySelector('.app');
let widget = document.querySelector('.widget');
let Container;
let domElement;
let isWidget = false;

if (app) {
  Container = InitMiddlewareComponent; // MainContainer;
  domElement = app;
}

if (widget) {
  isWidget = true;
  Container = InitMiddlewareComponent;
  domElement = widget;
}

const root = domElement ? createRoot(domElement) : null;

// Render the  into the DOM
root && root.render(
  <Provider store={store}>
    <Container isWidget={isWidget}/>
  </Provider>);
